import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ee0848"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row row-pharmacy mb-4" }
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = { class: "row row-information" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = { class: "row row-opening-hours mb-4" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "row row-content-block" }
const _hoisted_18 = { class: "col-12 mb-3" }
const _hoisted_19 = {
  key: 0,
  class: "col-12"
}
const _hoisted_20 = { class: "outline border-1 rounded p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_CbPharmacyInfoCb = _resolveComponent("CbPharmacyInfoCb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !this.isReady
    }, null, 8, ["spin"]),
    (this.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_InputSelect, {
                    modelValue: this.contentBlock.pharmacy_code,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((this.contentBlock.pharmacy_code) = $event)),
                      this.onChange
                    ],
                    options: this.pharmacyOptions,
                    label: _ctx.$t('branch'),
                    name: "pharmacy",
                    selectText: _ctx.$t('selectText'),
                    rules: "required",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
                ])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.showFollowingProperties'),
                mb: "3"
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_contactinfo,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((this.contentBlock.is_show_contactinfo) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('pharmacyContactInfo'),
                    name: "is_show_contactinfo",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_companyinfo,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((this.contentBlock.is_show_companyinfo) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('companyContactInfo'),
                    name: "is_show_companyinfo",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_pharmacy_holder,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((this.contentBlock.is_show_pharmacy_holder) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('titular'),
                    name: "is_show_pharmacy_holder",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_apb_number,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((this.contentBlock.is_show_apb_number) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('apbNumber'),
                    name: "is_show_apb_number",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_social_media,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((this.contentBlock.is_show_social_media) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('socialMedia'),
                    name: "is_show_social_media",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ])
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_openinghours_title,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((this.contentBlock.is_show_openinghours_title) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('cms.titleAboveOpeningHours'),
                    name: "is_show_openinghours_title",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_openinghours_today,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((this.contentBlock.is_show_openinghours_today) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('cms.openingHoursToday'),
                    name: "is_show_openinghours_today",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.contentBlock.is_show_openinghours_week,
                    "onUpdate:modelValue": [
                      _cache[8] || (_cache[8] = ($event: any) => ((this.contentBlock.is_show_openinghours_week) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('cms.openingHoursWeek'),
                    name: "is_show_openinghours_week",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('extraInformation'),
                mb: "3"
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: this.useTextWithImage,
                    "onUpdate:modelValue": [
                      _cache[9] || (_cache[9] = ($event: any) => ((this.useTextWithImage) = $event)),
                      this.onChange
                    ],
                    label: _ctx.$t('useContentBlock'),
                    name: "useTextWithImage",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                (this.useTextWithImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_CbPharmacyInfoCb, {
                          "content-block-payload": this.contentBlock.twi,
                          errors: _ctx.errors,
                          onChanged: this.onTextWithImageChanged,
                          onHasUnsavedChanges: this.onChange,
                          onExceptions: this.setExceptions
                        }, null, 8, ["content-block-payload", "errors", "onChanged", "onHasUnsavedChanges", "onExceptions"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}